import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const reportBuilderNRO: NavigationRoutingObject = {
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("report-builder-sidebar-pill-menu-option-legacy", "Report Builder (Legacy)"),
  getDeveloperNavigationAllowed: ({ isImpersonating, hasPermission, featureOn }) => {
    if (featureOn("disable_report_builder_1")) {
      return false;
    }
    if (!featureOn("report_builder_1_check_permissions")) {
      return true;
    }

    const userCanViewReporting = hasPermission("appGroupOrAnyTeamInAppGroup", {
      permission: "viewReporting",
    });
    return isImpersonating || userCanViewReporting;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("report-builder-alt-keyword-1", "custom report"),
        t("report-builder-alt-keyword-2", "compare campaigns"),
        t("report-builder-alt-keyword-3", "compare canvases"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
